import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { GridLayoutStateEffects } from './_state/grid-layout-state.effects';
import { GRID_LAYOUT_STATE_KEY } from './_state/grid-layout-state.model';
import { gridLayoutStateReducers } from './_state/grid-layout-state.reducers';

/** @deprecated DEV-14518 Legacy global dashboard is deprecated. Replacement under development. See ticket. */
@NgModule({
  imports: [
    StoreModule.forFeature(GRID_LAYOUT_STATE_KEY, gridLayoutStateReducers),
    EffectsModule.forFeature([GridLayoutStateEffects]),
  ],
})
export class GridLayoutModule {}
